import { useState, useEffect, useRef } from 'react'
import { QRCode } from 'react-qrcode-logo'
import { useEntityCrud } from './hooks/useEntityCrud'

import './components/Organizations/Index.css'
import ReactToPrint from 'react-to-print'

const BusinessQrList = () => {

    const ref = useRef()

    const [businesses,setBusinesses] = useState([])
    const [supportPhone,setSupportPhone] = useState('')
    const { readData: getSupportPhone } = useEntityCrud('Config/get')
    const { readData } = useEntityCrud('Business/GetAllBusinesses')
    const filters = localStorage.getItem('filter-data') ? JSON.parse(localStorage.getItem('filter-data')) : null;

    useEffect(() => {
        if(filters){
            readData(filters).then(( {data} ) => {
                setBusinesses(data.result)
            })
            localStorage.removeItem('filter-data');
        }else{
            readData().then(( {data} ) => {
                setBusinesses(data.result)
            })
        }
        getSupportPhone({key: 'support_phone'}).then(({data}) => {
            setSupportPhone(data.result.value)
        })
    },[])

    useEffect(() => {
        if(businesses.length){
            // setTimeout(() => {
                document.getElementById('download-list-btn').click()
            // },2000)
        }
    },[businesses])

    return (
        <>
        {businesses.length ? <ReactToPrint
            trigger={() => {
                return <button
                className="btn btn-info btn-block mt-4"
                id="download-list-btn"
                style={{display: 'none'}}
            >
                {" "}
                دریافت تصویر بارکد
            </button>
        }}
            content={() => ref.current}
            documentTitle="لیست QrCode ها"
        /> : ''}
        <div ref={ref}>
            {!businesses.length ? <p style={{position: 'absolute',width: '100%',textAlign: 'center',top: '50%',transform: 'translateY(50%)',fontSize: '18px'}}>در حال بارگذاری ...</p> : businesses.map(business => <div key={business.id} class="text-center qrCodeContainerRef" style={{ width: "148.5mm", height: "auto", margin: "0 auto 450px" }}>
                <img src="/assets/images/brand/logoPetro.png" width="30%" className="my-4 mx-auto text-center" />
                <h1 className="mb-0 py-4" style={{ fontSize: "35px" }}>
                    <b>
                        پرداخت با پتروکارت
                    </b>
                </h1>
                <div className="topBox d-flex flex-column justify-content-center align-items-center ">
                    <div className="">
                        <QRCode
                            bodyClass="mx-auto"
                            id="QRCode"
                            size={555}
                            logoImage="../../assets/images/favicon.jpg"
                            imageSettings={{
                                src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSshrGc3H1tmJPwlIDts0DaK67hMU45v6NH6y_5txdY&s",
                                excavate: true,
                            }}
                            level={"L"}
                            renderAs={"svg"}
                            value={`https://ipg.sabinarya.com/payment/ipg/qr/app/?terminalNumber=${business.terminalNo}&callback=https://petro.sabinarya.com`}
                        />
                    </div>
                </div>
                <div className="bottomBox  d-flex flex-column justify-content-center align-items-center">
                    <div className=" d-flex flex-column justify-content-center align-items-center">
                        <h3 class="text-center text-bold text-dark my-4" st>
                            <b>
                                نام پایانه : &nbsp;
                                {business.title || "-"}
                            </b>
                        </h3>
                        <h3 class="text-center text-dark text-bold mb-4">
                            <b>
                                شناسه پایانه : &nbsp;
                                {business.terminalNo || "-"}
                            </b>
                        </h3>
                    </div>
                    <h5 class="text-center my-4 text-dark">
                        <b>
                            شماره پشتیبانی
                            <span className="mx-1" dir="ltr"> {supportPhone}</span>
                        </b>
                    </h5>
                </div>
            </div>)}
        </div>
    </>
    )
}

export default BusinessQrList